import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all settingses
export const getSettings = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/settings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching settingses:", error.response?.data || error);
    throw error;
  }
};

// GET a single settings
export const getSettingsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/settings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching settings:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new settings
export const createSettings = async (settingsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/settings`, settingsData);
    return response.data;
  } catch (error) {
    console.error("Error creating settings:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing settings
export const updateSettings = async (id, settingsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/settings/${id}`, settingsData);
    return response.data;
  } catch (error) {
    console.error("Error updating settings:", error.response?.data || error);
    throw error;
  }
};

// DELETE a settings
export const deleteSettings = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/settings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting settings:", error.response?.data || error);
    throw error;
  }
};

// GET Settings for User's Organisation
export const getSettingsByOrg = async () => {
  try {
    const response = await axiosInstance.get('/settings/by-org');
    return response.data;
  } catch (error) {
    console.error("Error fetching settings:", error.response?.data || error);
    throw error;
  }
};
